// extracted by mini-css-extract-plugin
export default {"document":"DocumentNode_document__IYOAb","text":"DocumentNode_text__iYIwW"};